export interface EconomicNewsItem {
  id: string;
  title: string;
  summary: string;
  sector: string;
  date: string;
  impact: 'high' | 'medium' | 'low';
}

export const ECONOMIC_NEWS: EconomicNewsItem[] = [
  {
    id: 'dangote-ipo-announcement',
    title: 'Dangote Group Announces Mega IPO for Q4 2026',
    summary: 'Africa largest conglomerate, Dangote Group, has officially filed for a landmark initial public offering expected to raise over $4 billion, potentially making it the largest IPO in African history and reshaping the Nigerian Stock Exchange.',
    sector: 'Dangote Group',
    date: '2026-09-09',
    impact: 'high',
  },
  {
    id: 'dangote-refinery-production-milestone',
    title: 'Dangote Refinery Hits 500,000 Barrels Per Day Output',
    summary: 'The Dangote Refinery has reached a production milestone of 500,000 barrels per day, significantly reducing Nigeria reliance on imported refined petroleum and saving billions in foreign exchange outflows.',
    sector: 'Dangote Group',
    date: '2026-09-08',
    impact: 'high',
  },
  {
    id: 'dangote-cement-exports',
    title: 'Dangote Cement Exports Surge to $1.2B Amid African Expansion',
    summary: 'Dangote Cement Plc reports record export revenue of $1.2B in the first half of 2026, driven by strong demand across Sub-Saharan Africa and new production capacity in Ethiopia and Tanzania.',
    sector: 'Dangote Group',
    date: '2026-09-06',
    impact: 'medium',
  },
  {
    id: 'dangote-ipo-valuation',
    title: 'Dangote IPO Valuation Targeted at $25 Billion',
    summary: 'Sources close to the Dangote Group IPO process indicate a target valuation of approximately $25 billion, with shares to be listed on the Nigerian Exchange Group and through a cross-listing on the London Stock Exchange.',
    sector: 'Dangote Group',
    date: '2026-09-05',
    impact: 'high',
  },
  {
    id: 'oil-production-rebound',
    title: 'Nigeria Oil Production Rises to 1.65M Barrels Per Day',
    summary: 'Crude oil production has increased following improved security in the Niger Delta, boosting foreign exchange inflows and strengthening CBN reserves.',
    sector: 'Oil & Gas',
    date: '2026-09-08',
    impact: 'high',
  },
  {
    id: 'cbn-reserves-growth',
    title: 'External Reserves Hit $38 Billion Mark',
    summary: 'The Central Bank of Nigeria reports external reserves reaching $38B, providing a stronger buffer for currency defense and import financing.',
    sector: 'Monetary Policy',
    date: '2026-09-07',
    impact: 'high',
  },
  {
    id: 'inflation-rate-decline',
    title: 'Inflation Eases to 21.3% in August',
    summary: 'Headline inflation dropped for the third consecutive month as food prices stabilize and the Naira shows relative stability against the dollar.',
    sector: 'Inflation',
    date: '2026-09-06',
    impact: 'medium',
  },
  {
    id: 'agricultural-export-growth',
    title: 'Non-Oil Exports Hit $4.2B in Q2 2026',
    summary: 'Agricultural exports including sesame, cocoa, and cashew nuts drove non-oil export revenue to record levels, supported by government incentives.',
    sector: 'Agriculture',
    date: '2026-09-05',
    impact: 'medium',
  },
  {
    id: 'fintech-investment-surge',
    title: 'Nigerian Fintech Sector Attracts $1.8B in Funding',
    summary: 'Nigeria remains Africa top fintech destination with major investments in payment processing, digital lending, and cross-border remittance platforms.',
    sector: 'Technology',
    date: '2026-09-04',
    impact: 'medium',
  },
  {
    id: 'manufacturing-pmi-improves',
    title: 'Manufacturing PMI Expands to 52.4',
    summary: 'The purchasing managers index moved into expansion territory, signaling improved factory activity driven by stronger local demand and FX access.',
    sector: 'Manufacturing',
    date: '2026-09-03',
    impact: 'low',
  },
  {
    id: 'trade-balance-surplus',
    title: 'Nigeria Records Trade Surplus of N2.1 Trillion',
    summary: 'Higher crude exports and reduced import pressure from currency adjustments produced a trade surplus in Q2, supporting Naira stability.',
    sector: 'Trade',
    date: '2026-09-02',
    impact: 'medium',
  },
  {
    id: 'banking-sector-profitability',
    title: 'Banking Sector Profits Surge 45% Year-on-Year',
    summary: 'Major Nigerian banks report strong earnings driven by FX revaluation gains, higher interest margins, and digital banking growth.',
    sector: 'Banking',
    date: '2026-09-01',
    impact: 'low',
  },
];

export const ECONOMIC_SECTORS = [
  'Dangote Group', 'Oil & Gas', 'Monetary Policy', 'Inflation', 'Agriculture',
  'Technology', 'Manufacturing', 'Trade', 'Banking',
];
